import React from 'react';
import {Switch, Route} from 'react-router-dom';

import {ProjectsContainer} from './ProjectsContainer';
import {CvContainer} from './CvContainer';
import {EditorContainer} from './EditorContainer';

export const AppContainer = () => {
  return (
    <Switch>
        <Route path='/cv' component={CvContainer} />
        <Route path='/editor' component={EditorContainer} />
        <Route component={ProjectsContainer} />
    </Switch>
)};


// WEBPACK FOOTER //
// ./src/components/AppContainer.js